module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/pc.png?ebaad8c312e527cd98e3a6371891577c";